import src from "IMAGE";
export default { src, width: 183, height: 47, blurWidth: 0, blurHeight: 0};
